//import "flowbite";
import "@ungap/custom-elements";
import { HbTreasury } from "./components/hb-treasury.ts";
import { Location } from "./managers/Location.ts";

declare global {
    interface Window {
        earth: Location;
        tokenCursor: any;
        momentCursor: any;
    }
}

window.earth = new Location();
customElements.define("hb-treasury", HbTreasury, { extends: "body" });

document.addEventListener("DOMContentLoaded", async () => {
    if (
        location.hostname !== "localhost" &&
        location.hostname !== "127.0.0.1"
    ) {
        const script = document.createElement("script");
        script.defer = true;
        script.src = "https://static.cloudflareinsights.com/beacon.min.js";
        script.setAttribute(
            "data-cf-beacon",
            '{"token": "fbbf4f9669b2441392f5858a84176126"}'
        );
        document.head.appendChild(script);
    }

    document.body.style.visibility = "visible";
});
